import { IconWrapper } from '../runtime';
export default IconWrapper('highlight-block', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 16 16",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "d": "M1.75 10.4997H8.25391M1.75 14.2497H13.25M3.25 6.74969H12.75C13.5784 6.74969 14.25 6.07812 14.25 5.24969V3.24969C14.25 2.42127 13.5784 1.74969 12.75 1.74969H3.25C2.42157 1.74969 1.75 2.42127 1.75 3.24969V5.24969C1.75 6.07812 2.42157 6.74969 3.25 6.74969Z",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linecap": props.strokeLinecap,
      "stroke-linejoin": props.strokeLinejoin,
      "vector-effect": "non-scaling-stroke"
    }
  })]);
});